import {KitchenDramaSushiManiaGameAssets} from "../KitchenDramaSushiManiaGameAssets";


/**
 * Created by jonas on 2022-02-01.
 */

export class KitchenDramaSushiManiaTextStyles {

    public static WIN_COUNT_UP = {
        fontName : KitchenDramaSushiManiaGameAssets.BITMAP_FONT_WIN_COUNT_UP,
        fontSize : 128,
        tint : 0xffffff
    }

    static KOMIKA_BM_MONOSPACED = {
        fontName : KitchenDramaSushiManiaGameAssets.BITMAP_FONT_WIN_COUNT_UP,
        fontSize : 105
    };

    public static WIN_COUNT_UP_TOGGLE= {
        fontName : KitchenDramaSushiManiaGameAssets.BITMAP_FONT_WIN_COUNT_UP,
        fontSize : 128 * 0.8,
        tint : 0xffffff
    }

    public static FREESPIN_INTRO_INFORMATION:PIXI.TextStyle  = new PIXI.TextStyle({
        fontFamily : "Komika Text InGame",
        fontSize : 30,
        fill : 0xFFFFFF,
        stroke : 0x493b5a,
        strokeThickness : 4,
        dropShadow : true,
        dropShadowColor : 0x493b5a,
        dropShadowAngle : 60 * PIXI.DEG_TO_RAD,
        dropShadowDistance : 2,
        miterLimit : 5,
        padding : 5,
        wordWrap : true,
        wordWrapWidth : 680
    });

    public static FEATURE_SPLASH_TEXT_STYLE:PIXI.TextStyle  = new PIXI.TextStyle({
        fontFamily : "Komika Text InGame",
        fontSize : "30px",
        fontWeight : "800",
        fill : "#fffbc5",
        stroke : "#805a00",
        strokeThickness : 2,
        dropShadow : true,
        dropShadowColor : "#805a00",
        dropShadowAngle : 1.04719755,
        dropShadowDistance : 2,
        padding : 5
    });


    public static WIN_AMOUNT_TEXT:PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily : "Komika Text InGame",
        fontSize : "50px",
        fontWeight : "800",
        fill : "#fffbc5",
        stroke : "#805a00",
        strokeThickness : 2,
        dropShadow : true,
        dropShadowColor : "#805a00",
        dropShadowAngle : 1.04719755,
        dropShadowDistance : 2,
        padding : 5
    })

    public static WIN_AMOUNT_TEXT_WHITE:PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily : "Komika Text InGame",
        fontSize : "50px",
        fontWeight : "800",
        fill : "#ffffff",
        stroke : "#ffffff",
        strokeThickness : 2,
        dropShadow : true,
        dropShadowColor : "#ffffff",
        dropShadowAngle : 1.04719755,
        dropShadowDistance : 2,
        padding : 5
    })

    static WIN_AMOUNT_DISPLAY_NUMBERS_BIG_STYLE:PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily : "Komika Text InGame",
        fontSize : "120px",
        fontWeight : "800",
        fill : "#fffbc5",
        stroke : "#805a00",
        strokeThickness : 4,
        dropShadow : true,
        dropShadowColor : "#805a00",
        dropShadowAngle : 1.04719755,
        dropShadowDistance : 4,
        padding : 5
    });

    static WILD_SUSHI_LOGO:PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily : "Futura LT",
        fontSize : "80px",
        fill : "#FBD8C9",
        stroke : "#754c64",
        strokeThickness : 5,
        dropShadow : true,
        dropShadowColor : "#49303e",
        dropShadowAngle : 1.5708,
        dropShadowDistance : 7,
        letterSpacing : -4,
        padding : 0
    });

    static KEY_FS_INTRO_YOU_WON_STYLE:PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily : "Futura LT",
        fontSize : "70px",
        fill : "#dec9fb",
        stroke : "#674f77",
        strokeThickness : 5,
        dropShadow : true,
        dropShadowColor : "#674f77",
        dropShadowAngle : 1.5708,
        dropShadowDistance : 7,

        padding : 0
    });

    static BIG_WIN_TEXT:PIXI.TextStyle = new PIXI.TextStyle({
        fontFamily : "Futura LT",
        fontSize : "105px",
        fill : "#e5e4c3",
        stroke : "#343315",
        letterSpacing : -7,
        strokeThickness : 5,
        dropShadow : true,
        dropShadowColor : "#343315",
        dropShadowAngle : Math.PI * 0.5,
        dropShadowDistance : 5,
        padding : 0
    });



}